var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1177 0.317718C16.5061 0.317718 16.8272 0.606399 16.878 0.980943L16.885 1.08507V3.97893C16.885 4.36741 16.5963 4.68846 16.2218 4.73927L16.1177 4.74628H13.2238C12.8 4.74628 12.4565 4.40272 12.4565 3.97893C12.4565 3.59045 12.7451 3.26939 13.1197 3.21858L13.2238 3.21158L14.2025 3.21112C11.2899 0.870369 7.02027 1.05139 4.31748 3.75418C1.42068 6.65097 1.42068 11.3476 4.31748 14.2444C7.21428 17.1412 11.9109 17.1412 14.8077 14.2444C16.5707 12.4815 17.3088 9.99189 16.8458 7.58854C16.7656 7.1724 17.0379 6.77006 17.4541 6.68988C17.8702 6.60971 18.2726 6.88206 18.3528 7.29821C18.9111 10.1965 18.0199 13.2027 15.8929 15.3296C12.3968 18.8257 6.72842 18.8257 3.23228 15.3296C-0.263855 11.8335 -0.263855 6.16512 3.23228 2.66898C6.55289 -0.651632 11.8331 -0.818347 15.3505 2.16883L15.3503 1.08507C15.3503 0.661272 15.6939 0.317718 16.1177 0.317718Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reload-icon.acc73484c617f32c5a7da64dff05bd43.svg";
export { ForwardRef as ReactComponent };